import utils from 'utils'

class goodsContrastListCtrl {
    constructor($scope, httpRequest, $state, sweetalert, logger, initSortService) {
        $scope.selectedRow = []
        let initParam = {
            custConfig: '', //指定购方内容多个 
            goodsCode: '', // 商品编码
            goodsName: '', //开票商品名称
            measureUnit: '', //开票计量单位
            originGoodsName: '', //原商品名称
            originMeasureUnit: '', // 原计量单位 
            originSpecifications: '', // 原规格型号 
            specifications: '', //开票规格型号
            taxRate: '' // 税率：数字
        }
        $scope.queryParam = {
            pageSize: 10,
            pageNum: 1,
            param: JSON.parse(JSON.stringify(initParam)),
        }
        $scope.reset = function () {
            $scope.queryParam.param = JSON.parse(JSON.stringify(initParam))
        }
        $scope.selectedContrast = [] //选中项
        // $scope.reset()
        // 表头排序
        $scope.orderMap = initSortService('goodsContrastParam')
        $scope.selectedHandle = function () {
            $scope.queryParam.orderMap = {}
            if ($scope.orderMap.sortKey) $scope.queryParam.orderMap[$scope.orderMap.sortKey] = $scope.orderMap.sortVal
            sessionStorage.setItem('goodsContrastParam', JSON.stringify($scope.queryParam))
            $scope.queryOrgInfo()
        }
        const queryOrgInfo = function queryOrgInfo() {
            $scope.queryParam = sessionStorage.goodsContrastParam ? JSON.parse(sessionStorage.goodsContrastParam) : $scope.queryParam
            const openLoading = $scope.queryParam.pageSize >= 100 ? window.layer.msg('正在查询，请耐心等待', {
                time: 0,
                skin: 'layer-loading-self',
                icon: 16,
                shade: 0.5,
            }) : null
            httpRequest.post_sysGoodsMapping($scope.queryParam).then((res) => {
                $scope.selectedRow = []
                $scope.listData = res.data.value.list
                $scope.totalItems = res.data.value.total
                $scope.queryParam.pageNum = res.data.value.pageNum
            }).finally(() => {
                window.layer.close(openLoading)
            })
        }
        $scope.searchList = function () {
            sessionStorage.setItem('goodsContrastParam', JSON.stringify($scope.queryParam))
            queryOrgInfo()
        }
        // 分页
        $scope.pageChanged = function () { // 点击页码发起查询
            sessionStorage.setItem('goodsContrastParam', JSON.stringify({
                orderMap: $scope.queryParam.orderMap,
                pageNum: $scope.queryParam.pageNum,
                pageSize: $scope.queryParam.pageSize,
                param: sessionStorage.goodsContrastParam ? JSON.parse(sessionStorage.goodsContrastParam).param : JSON.parse(JSON.stringify(initParam))
            }))
            queryOrgInfo()
        }
        const typecodeArrStr = '["taxplayer_type", "status", "company_type","is_privilege"]'
        httpRequest.get_dictByTypeArr(typecodeArrStr).then((res) => {
            $scope.dictionary = res.data.value
        })
        queryOrgInfo()
        $scope.queryOrgInfo = queryOrgInfo
        $scope.tableDropdownConfig = [{
                label: '编辑',
                handler(item) {
                    $state.go('outputManage.ovat.goodsContrast.edit', {
                        id: item.mappingId,
                    })
                },
                showWhile(item, hasPermit) {
                    return hasPermit('add_contrast')
                },
            },
            {
                label: '删除',
                handler(item) {
                    sweetalert.confirm('删除提醒', '确认删除此条对照商品吗?').then(() => {
                        httpRequest.get_sysGoodsMappingDel(item.mappingId, '删除成功！').then(() => {
                            if ($scope.listData.length == 1 && $scope.queryParam.pageNum > 1) {
                                $scope.queryParam.pageNum -= 1
                                sessionStorage.setItem('goodsContrastParam', JSON.stringify($scope.queryParam))
                            }
                            queryOrgInfo()
                        })
                    })
                },
                showWhile(item, hasPermit) {
                    return hasPermit('del_contrast')
                },
            },
        ]

        $scope.importconfig = {
            code: 'GOODS_MAPPING',
            validate: {
                pattern: '.xlsx,.xls',
                _validate: {
                    size: {
                        min: 10,
                        max: '10MB'
                    },
                    duration: {
                        min: '10s',
                        max: '5m'
                    },
                    accept: '.xlsx,.xls',
                },
            },
            callback() {
                // 回掉，可选
                $scope.queryOrgInfo()
            },
            appName: host.etcloudOvat,
            url: 'dlTaskService/import_GOODS_MAPPING',
            downloadAppName: host.etcloudOvat,
        }
        $scope.customizedConfig = {
            version: 1.142,
            queryConfig: [{
                    label: '商品编号',
                    selected: true,
                    default: true,
                }, {
                    label: '原商品名称',
                    selected: true,
                    default: true,
                },
                {
                    label: '原规格型号',
                    selected: true,
                    default: true,
                },
                {
                    label: '原计量单位',
                    selected: true,
                    default: true,
                },
                {
                    label: '开票商品名称',
                    selected: false,
                    default: false,
                }, {
                    label: '开票规格型号',
                    selected: false,
                    default: false,
                },
                {
                    label: '开票计量单位',
                    selected: false,
                    default: false,
                },
                {
                    label: '生效购方',
                    selected: false,
                    default: false,
                },
                {
                    label: '税率',
                    selected: false,
                    default: false,
                },
            ],
            table: [{
                    label: '商品编号',
                    selected: true,
                    default: true,
                }, {
                    label: '原商品名称',
                    selected: true,
                    default: true,
                }, {
                    label: '原规格型号',
                    selected: true,
                    default: true,
                }, {
                    label: '原计量单位',
                    selected: true,
                    default: true,
                }, {
                    label: '开票商品名称',
                    selected: true,
                    default: true,
                }, {
                    label: '开票规格型号',
                    selected: true,
                    default: true,
                }, {
                    label: '开票计量单位',
                    selected: true,
                    default: true,
                }, {
                    label: '生效购方',
                    selected: false,
                    default: false,
                },
                {
                    label: '单位换算率',
                    selected: false,
                    default: false,
                },
                {
                    label: '税率',
                    selected: false,
                    default: false,
                },
                {
                    label: '简称',
                    selected: false,
                    default: false,
                },
                {
                    label: '税分合并编码',
                    selected: false,
                    default: false,
                },
                {
                    label: '是否享受优惠政策',
                    selected: false,
                    default: false,
                },
                {
                    label: '优惠政策类型',
                    selected: false,
                    default: false,
                }
            ],
        }
        // 税率数组
        httpRequest.get_queryGoodsTax({
            taxMergeCode: -1,
            invType: -1,
        }).then((res) => {
            $scope.taxRateList = res.data.value
        })

        // 批量删除
        $scope.batchDelete = () => {
            if ($scope.selectedRow && $scope.selectedRow.length > 0) {
                const mappingIds = $scope.selectedRow
                sweetalert.confirm('删除提醒', '删除后该商品不再进行对照开票，确认删除吗？').then(() => {
                    httpRequest.get_sysGoodsMappingBatchDel(mappingIds).then((res) => {
                        logger.logSuccess('删除成功')
                        $scope.queryParam.pageNum = 1
                        sessionStorage.setItem('goodsContrastParam', JSON.stringify($scope.queryParam))
                        queryOrgInfo()
                    })
                })
            } else {
                logger.logError('请选择要删除的数据')
            }
        }

        // 导出
        $scope.exportExcel = function () {
            let params = {
                mappingIdList: $scope.selectedRow,
                ...$scope.queryParam.param
            }
            let url = `${host.etcloudOvat}settings/sysGoodsMapping/exportToExcel?accessToken=${localStorage.getItem('id_token')}`
            for (let i in $scope.queryParam.orderMap) {
                params.sortField = i + ':' + $scope.queryParam.orderMap[i]
            }
            utils.post_downLoad(params, url)
        }
    }
}
goodsContrastListCtrl.$inject = ['$scope', 'httpRequest', '$state', 'sweetalert', 'logger', 'initSortService']
export default goodsContrastListCtrl


// WEBPACK FOOTER //
// ./src/app/outputManage/baseData/goodsContrast/goodsContrastListCtrl.js